import { useStateSelector } from '../store/selectors';

/**
 * Returns the correct dashboard path based on isBuiltInMode redux state.
 * Usage: const dashboardPath = useDataRequestDashboardPath();
 */
export const useDataRequestUrl = (toEditorMode?: boolean) => {
    const isBuiltInMode = useStateSelector(
        (s) => s.appConfigs.values.isBuiltInMode
    );
    if (toEditorMode) {
        return isBuiltInMode ? 'project-editor-built-in' : 'project-editor';
    }
    return isBuiltInMode
        ? 'data-request-dashboard-built-in'
        : 'data-request-dashboard';
};
